export default "__VITE_ASSET__CUG0IduG__"